// Purpose: Complete the shared email/password signup process after Firebase creates an account.
// Dependencies: Firebase Auth/Firestore singletons and the configured verification redirect.
// Behavior: Saves a normal voter profile, sends verification, and never stores the password.
import { sendEmailVerification } from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../firebase";

export async function completeEmailRegistration(user, { firstName, lastName, phone = "", mailingConsent = false, agreedToTerms }) {
  if (!agreedToTerms || !firstName.trim() || !lastName.trim()) {
    throw new Error("Complete your name and accept the Terms & Conditions.");
  }
  if (!user?.uid || auth.currentUser?.uid !== user.uid) {
    throw new Error("Sign in to finish creating your account.");
  }
  await setDoc(doc(db, "users", user.uid), {
    uid: user.uid,
    email: user.email,
    firstName: firstName.trim(),
    lastName: lastName.trim(),
    phone,
    role: "voter",
    mailingConsent,
    createdAt: serverTimestamp(),
  }, { merge: true });
  await sendEmailVerification(user, {
    url: process.env.REACT_APP_VERIFY_EMAIL_REDIRECT,
    handleCodeInApp: true,
  });
}
